module.exports = __webpack_public_path__ + "img/kiosk-search-categories.1208cb60.webp";